var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-aside'),_c('v-main',{staticClass:"main"},[_c('v-container',{attrs:{"fluid":""}},[(_vm.routeIsAllowed)?[_c('router-view',{key:_vm.$route.path})]:_c('access-denied')],2),_c('update-app-massage')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }